// Generated by CoffeeScript 2.7.0
var Ajax, GlobalID, MessageCards, STATES_MAP, adminUrlFor, generateUrlWithParams, uuid;

import Popover from './popover.js';

import {
  PopoverGroupOptions
} from 'trunks/vue/admin/components/popover_group_options.js';

import CollaboratorsSelect from 'trunks/vue/admin/compositions/collaborators_select.js';

({adminUrlFor, generateUrlWithParams} = Skylark.Helpers.UrlHelper);

({uuid} = Skylark.Helpers.Utilities);

({Ajax, GlobalID} = Skylark.Libs);

STATES_MAP = {
  unread: '未读',
  uncompleted: '未填写',
  completed: '已完成'
};

MessageCards = {};

MessageCards.Receipts = class Receipts {
  constructor(modal, gid, queryText) {
    this.modal = modal;
    this.gid = gid;
    this.queryText = queryText;
    this.modal = DomMaster.wrap(this.modal);
    if (this.modal.isPresent()) {
      this.prepareFilter();
      this.prepareDownload();
    }
  }

  prepareFilter() {
    var checkbox_selector, filter_url, option_checkboxes, receipts_filter_options;
    receipts_filter_options = this.modal.find('.js-receipts-filter-options');
    checkbox_selector = "input[type='checkbox']";
    option_checkboxes = receipts_filter_options.findAll(checkbox_selector);
    this.states = _.map(option_checkboxes, function(checkbox_el) {
      return checkbox_el.node.value;
    });
    this.selectedStates = _.chain(option_checkboxes).map(function(checkbox_el) {
      return checkbox_el.node.checked && checkbox_el.node.value;
    }).value();
    filter_url = adminUrlFor(`${this.gid.toPath()}/cards/receipts`);
    return receipts_filter_options.node.proxy('change', checkbox_selector, (ev) => {
      var states;
      states = _.chain(option_checkboxes).map(function(checkbox_el) {
        return checkbox_el.node.checked && checkbox_el.node.value;
      }).value();
      return Ajax.get(generateUrlWithParams(filter_url, {
        states: states,
        name: this.queryText
      }), {
        responseType: 'script'
      });
    });
  }

  prepareDownload() {
    var download_url, generateOptionsFunc, popover_el;
    popover_el = this.modal.find('.js-receipts-download-popover');
    download_url = adminUrlFor(`${this.gid.toPath()}/receipts/export`);
    generateOptionsFunc = () => {
      return _.map(this.states, function(state) {
        return {
          id: state,
          name: STATES_MAP[state]
        };
      });
    };
    return new Popover(popover_el.node, {
      size: 'small',
      type: 'select',
      beforeOpenFunc: function(popover) {
        if (popover._state_group_options) {
          return;
        }
        return popover._state_group_options = new Vue({
          el: popover_el.find('.receipts-download-options').node,
          components: {
            'popover-group-options': PopoverGroupOptions
          },
          template: `<popover-group-options :initialSelectedOptionIds="['unread', 'uncompleted', 'completed']"
                       :formatDataFunc='formatDataFunc'
                       :needFilterInput='false'
                       @cancelClicked='cancelFunc'
                       @submitClicked='submitFunc'>
  <template slot='option-item-template' slot-scope='{ option }'>
    <div class='tip gray-text'>
      <i :class='option.icon'></i>
    </div>
    <div class='content'>
      <span>{{ option.name }}</span>
    </div>
    <i class='tip primary-text' :class="option._selected ? 'slp-check-circle' : 'slp-empty'"></i>
  </template>
</popover-group-options>`,
          methods: {
            formatDataFunc: function() {
              return [
                {
                  id: uuid(),
                  options: generateOptionsFunc()
                }
              ];
            },
            cancelFunc: function() {
              return popover.close();
            },
            submitFunc: function(selectedOptionIds) {
              Ajax.get(download_url, {
                responseType: 'script',
                data: {
                  states: selectedOptionIds
                }
              });
              return popover.close();
            }
          }
        });
      }
    });
  }

};

MessageCards.Collaborators = class Collaborators {
  constructor(modal, global_id) {
    var collaborator_ids_str;
    this.modal = modal;
    this.gid = new GlobalID(global_id);
    this.patch_url = adminUrlFor(`${this.gid.toPath()}/cards/collaborators`);
    this.delete_url = adminUrlFor(`${this.gid.toPath()}/collaborators/delete`);
    this.modal = DomMaster.wrap(this.modal);
    this.collaborators_popover_el = this.modal.find('.collaborators-popover');
    this.collaborator_ids = _.isString(collaborator_ids_str = this.collaborators_popover_el.data('collaborator-ids')) ? _.compact(_.map(collaborator_ids_str.split(','), function(id) {
      return parseInt(id);
    })) : [];
    this.prepareAddCollaboratorsPopover();
  }

  prepareAddCollaboratorsPopover() {
    var tbody_el;
    this.modal.find('.js-add-collaborator-btn').node.proxy('click', (event) => {
      event.stopPropagation();
      if (this.collaborators_popover != null) {
        return this.collaborators_popover.open();
      }
      this.collaborators_popover = new Popover(this.collaborators_popover_el, {
        size: 'default',
        type: 'select',
        beforeOpenFunc: (popover) => {
          if (this.collaborators_select) {
            return this.collaborators_select.reset();
          } else {
            this.collaborators_select = new CollaboratorsSelect({
              el: this.modal.find('.collaboratos-add-container').node,
              propsData: {
                initialSelectedCollaboratorIds: this.collaborator_ids
              }
            });
            return this.collaborators_select.$on('optionsChanged', function() {
              return popover.__calculatePosition();
            }).$on('cancelClicked', () => {
              return this.collaborators_popover.close();
            }).$on('submitClicked', (value) => {
              return Ajax.patch(this.patch_url, {
                contentType: 'application/json; charset=utf-8',
                responseType: 'script',
                data: {
                  way: 'modal',
                  [`${this.gid.model_name.demodulize().underscore()}`]: {
                    collaborator_ids: value
                  }
                }
              });
            });
          }
        }
      });
      return this.collaborators_popover.open();
    });
    tbody_el = this.modal.find('.js-collaborator-tbody');
    if (!tbody_el.isPresent()) {
      return;
    }
    return tbody_el.node.proxy('click', '.js-collaborator-remove-btn', (event) => {
      var collaborator_id, el;
      el = DomMaster.wrap(event._target);
      collaborator_id = el.data('id');
      el.html('删除中...');
      return Ajax.delete(`${this.delete_url}?user_id=${collaborator_id}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'script',
        success: () => {
          el.closest('tr').remove();
          return this._removeCollaborator(parseInt(collaborator_id));
        }
      });
    });
  }

  _removeCollaborator(id) {
    var index;
    id = parseInt(id);
    if ((index = _.indexOf(this.collaborator_ids, id)) !== -1) {
      return this.collaborator_ids.splice(index, 1);
    }
  }

};

MessageCards.RedPackets = class RedPackets {
  constructor(modal) {
    var red_packet_setting_cards_el;
    this.modal = modal;
    this.modal = DomMaster.wrap(this.modal);
    red_packet_setting_cards_el = this.modal.find('.red-packet-setting-cards');
    this.modal.find('.js-toggle-settings-card').node.proxy('click', function(event) {
      DomMaster.wrap(event._target).toggleClass('open');
      return red_packet_setting_cards_el.toggle();
    });
  }

};

export default MessageCards;
